import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class FreeOpenTableOptionListAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getFreeOpenTableOptionList', {
      url: '/admin/shopFree/index',
      name: 'list',
      label: '列表'
    }],
    ['addFreeOpenTableDuration', {
      url: '/admin/shopFree/add',
      name: 'add-duration',
      label: '新增时长'
    }],
    ['exportExcelFreeOpenTableOptionList', {
      url: '/admin/shopFree/export',
      name: 'export-excel',
      label: '导出'
    }],
    ['getShopFreeConfig', {
      url: '/admin/shopFree/getConfig',
      name: 'get-config',
      label: '获取免费时长比例配置'
    }],
    ['setShopFreeConfig', {
      url: '/admin/shopFree/setConfig',
      name: 'set-config',
      label: '设置免费时长比例配置'
    }],
  ])

  // 免开台记录列表
  public getFreeOpenTableOptionList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getFreeOpenTableOptionList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 新增时长
  public addFreeOpenTableDuration(params: any, successCb: Function, failCb: Function, showLoading: boolean = true) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addFreeOpenTableDuration').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 导出免开台记录列表
  public exportExcelFreeOpenTableOptionList(params: any, successCb: Function, failCb: Function, showLoading: boolean = true) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('exportExcelFreeOpenTableOptionList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 获取免费时长比例配置
  public getShopFreeConfig(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getShopFreeConfig').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 设置免费时长比例配置
  public setShopFreeConfig(params: any, successCb: Function, failCb: Function, showLoading: boolean = true) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('setShopFreeConfig').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }
}